import script from "./ActiveLoansTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ActiveLoansTable.vue?vue&type=script&setup=true&lang=js"

import "./ActiveLoansTable.vue?vue&type=style&index=0&id=5c52c9c1&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c52c9c1"]])

export default __exports__